<script setup lang="ts">
import { defineProps } from "vue";
import { convertSecondsFromStringTime } from "@/services/functions";
import HeaderRow from "@/components/MonthlyReportWorkingTimesSettingParts/SummaryTableParts/HeaderRow";
import SummaryRow from "@/components/MonthlyReportWorkingTimesSettingParts/SummaryTableParts/SummaryRow";

import SubHeaderRow from "@/components/MonthlyReportWorkingTimesSettingParts/SubSummaryTableParts/HeaderRow";
import SubSummaryRow from "@/components/MonthlyReportWorkingTimesSettingParts/SubSummaryTableParts/SummaryRow";
type Props = {
  detailDataRef: any;
  restraintTime?: string;
  workingTime?: string;
  mileage?: number;
  drivingTime?: string;
  breakTime?: string;
  loadingTime?: string;
  unloadingTime?: string;
  shippingTime?: string;
  waitTime?: string;
  othersTime?: string;
  restTime?: string;
  leavingDiffTime?: string;
  overTime?: string;
  midnightWorkingTime?: string;
  boundTimeByDays?: string;
  average?: string;
  boundTimeByHours?: string;
  workingDays?: number;
  alertSetting?: any;
};

const props = defineProps<Props>();

const boundDayColor = () => {
  if (!props.workingDays || !props.boundTimeByDays) return "black";
  if (props.boundTimeByDays == "0") return "black";

  return Number(props.workingDays) > Number(props.boundTimeByDays)
    ? "red"
    : "black";
};
</script>

<template>
  <div
    class="d-flex justify-content-between summary-times-container pt-0"
    style="padding-bottom: 10px"
  >
    <div>
      <table>
        <HeaderRow />
        <SummaryRow
          :detailDataRef="detailDataRef"
          :alertSetting="alertSetting"
        />
      </table>
    </div>
    <div>
      <table>
        <SubHeaderRow />
        <SubSummaryRow
          :detailDataRef="detailDataRef"
          :boundTimeByHours="boundTimeByHours"
          :boundTimeByDays="props.boundTimeByDays"
        />
      </table>
    </div>
  </div>
</template>

<style scoped>
.summary-times-container td {
  padding: 7px;
  text-align: center;
  font-weight: bold !important;
  border: 1 !important;
  border-width: 2px !important;
}
.summary-times-container .table-header {
  background-color: silver !important;
}
.summary-times-container tr {
  line-height: 15px;
  font-size: 13px;
}
</style>
